import axios from "@/axios";
import Vue from 'vue'

const state = {
  items: []
};

const actions = {
  fetchAccountItems({commit, state}) {
    return axios.get('account/items')
      .then((r) => {
        //on success when items change
        if (r.data.success && JSON.stringify(r.data.items) !== JSON.stringify(state.items)) {
          commit('SAVE_ITEMS', r.data.items)
        }
      })
  },
};

const mutations = {
  SAVE_ITEMS(state, items) {
    Vue.set(state, 'items', items);
  }
};

export default {
  state, actions, mutations
}
